const ru = {
    promocodeDiscount: 'Ваша скидка по промокоду:',
    promocodeDiscountEmpty: 'Промокод применён!',
    promocodeDiscountAdditional: 'Ваша дополнительная скидка по промокоду:',

    streetInputTitle: 'Улица, номер дома',
    flat: 'Квартира',
    entrance: 'Подъезд',

    pay: 'Оплатить',
    order: 'Оформить заказ',
};
const en = {
    promocodeDiscount: 'Your discount:',
    promocodeDiscountEmpty: 'Promocode applied!',
    promocodeDiscountAdditional: 'Your additional discount:',


    streetInputTitle: 'Street, house number',
    flat: 'Flat',
    entrance: 'Entrance',

    pay: 'Pay',
    order: 'Order',
};

export const locales = {
    ru,
    en,
};
